export class FilterUsedLabels {

	static selector = '.js-filter__labels';

	parent;
	filter;
	container;
	labels = [];

	constructor(parent, filter, container) {
		this.parent = parent;
		this.filter = filter;
		this.container = container;
		this.render();
	}

	render() {
		let self = this;
		self.container.innerHTML = '';

		let wrapper = document.createElement('div');
		wrapper.classList.add('c-tk-filter__labels-wrapper');

		self.labels = self.labels.filter((item, index) => {
			let firstSameIndex = -1;
			self.labels.forEach((element, index2) => {
				if (element.content === item.content && firstSameIndex === -1) {
					firstSameIndex = index2;
				}
			})
			return firstSameIndex === index;
		});

		self.labels.map(label => {
			wrapper.appendChild(label.getHtml());
		})

		self.container.appendChild(wrapper);

		if (self.labels.length === 0) {
			self.container.classList.add('empty');
		} else {
			self.container.classList.remove('empty');
			wrapper.appendChild(self.buildRemoveAllButton());
		}
	}

	buildRemoveAllButton() {
		let self = this;

		let button = document.createElement('button');
		button.type = 'button';
		button.classList.add('c-tk-filter__labels-remove');
		button.innerHTML = self.container.dataset.removeButtonContent;
		button.addEventListener('click', function () {
			return self.dismissAll();
		});

		return button;
	}

	dismissAll() {
		let self = this;

		self.disableFilterUpdate();
		self.labels.map(label => {
			label.dismiss();
		});

		self.forceFilterUpdate();
	}

	setLabels(labels) {
		let self = this;

		self.labels = labels;
		this.render();
	}

	enableFilterUpdate() {
		let self = this;
		self.filter['enabledUpdate'] = true;
	}

	disableFilterUpdate() {
		let self = this;
		self.filter['enabledUpdate'] = false;
	}

	forceFilterUpdate() {
		let self = this;
		self.enableFilterUpdate();
		self.filter['forceUpdate']();
	}
}
